import React, { Component } from "react";
import RenderTable from "../common/table";
import { Icon } from "semantic-ui-react";
import auth from "../../services/authService";

class PageTable extends Component {
  columns = [
    {
      path: "title",
      label: "Title",
      width: "7"
    },
    {
      path: "slug",
      label: "Slug",
      width: "7"
    },
    {
      key: "actions",
      width: "2",
      content: type =>
      //auth.getCurrentUser().email === "company-unblocker@gondalgroup.ae" && (
          <div>
            <Icon
              name="trash"
              color="red"
              className="clickable"
              onClick={() => this.props.onDelete(type)}
            />

            <Icon
              name="edit"
              color="blue"
              className="clickable"
              onClick={() => this.props.onUpdate(type)}
            />
          </div>
       // )
    }
  ];

  render() {
    const { types, onSort, sortColumn } = this.props;

    return (
      <RenderTable
        columns={this.columns}
        data={types}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default PageTable;
